<div *ngIf="loading" style="z-index: 9999;">
  <app-loading [userType]="'employee'"></app-loading>
</div>
<!-- TABLA DE TRANSACCIONES -->
<div id="whole-container">
  <div class="container-customize">
    <form [formGroup]="form">
      <div class="row">
        <div class="filters">
          <!-- FILTER -->
          <div>
            <input
              (input)="onTextFilterChange()"
              formControlName="user"
              class="form-control form-control--squared form-control--small"
              placeholder="{{ 'company.transaction.filters.user' | translate }}"
            />
          </div>
          <div>
            <input
              (input)="onTextFilterChange()"
              formControlName="department"
              class="form-control form-control--squared form-control--small"
              placeholder="{{
                'company.transaction.filters.department' | translate
              }}"
            />
          </div>
          <div>
            <select
              type="text"
              formControlName="type"
              id="type"
              class="form-control form-control--squared form-control--small select-input"
              (change)="setPage()"
            >
              <option selected hidden value="">
                {{ "common.none" | translate }}
              </option>
              <option [value]="'pending'">
                {{ "company.transaction.filters.type-pending" | translate }}
              </option>
              <option [value]="'payment'">
                {{ "company.transaction.filters.type-payment" | translate }}
              </option>
              <option [value]="'refund'">
                {{ "company.transaction.filters.type-refund" | translate }}
              </option>
              <option [value]="'cancelled'">
                {{ "company.transaction.filters.type-cancelled" | translate }}
              </option>
              <option [value]="'pendingCancel'">
                {{ "company.transaction.filters.pending-cancelled" | translate }}
              </option>
            </select>
          </div>
          <div>
            <input
              class="form-control form-control--squared form-control--small filter-dates"
              (dateSelect)="onDateSelection($event, 'fromDate')"
              placeholder="{{ 'project.form.initDate' | translate }}"
              #dateDep
              ngbDatepicker
              #d="ngbDatepicker"
              (click)="d.toggle()"
              readonly
              [ngClass]="
                !form.get('fromDate')?.value
                  ? 'filter-dates-placeholder'
                  : ''
              "
            />
          </div>
          <div>
            <input
              class="form-control form-control--squared form-control--small filter-dates"
              readonly
              placeholder="{{ 'project.form.endDate' | translate }}"
              ngbDatepicker
              #date="ngbDatepicker"
              #dateRet
              (dateSelect)="onDateSelection($event, 'toDate')"
              (click)="date.toggle()"
              [ngClass]="
                !form.get('toDate')?.value
                  ? 'filter-dates-placeholder'
                  : ''
              "
              [disabled]="!form.get('fromDate')?.value"
              [minDate]="minToDate"
            />
          </div>
          <div class="text-center align-middle" id="filters-buttons">
            <button
              type="button"
              [ngClass]="canClean() ? 'clear-btn red' : 'clear-btn'"
              type="button"
              (click)="cleanFilters()"
            >
              {{ "common.clean" | translate }}
              <img
                src="{{
                  !canClean()
                    ? 'assets/img/svg/grey-cross.svg'
                    : 'assets/img/svg/red-cross.svg'
                }}"
              />
            </button>
          </div>
        </div>
      </div>
      <table *ngIf="transactions.length > 0" class="table table-hover mb-0 table-groups">
        <thead>
          <th scope="col" class="align-text">
            {{ "company.transaction.filters.user" | translate }}
          </th>
          <th scope="col" class="align-text">
            {{ "company.transaction.origin-destination" | translate }}
          </th>
          <th scope="col">
            {{ "company.transaction.order-code" | translate }}
          </th>
          <th scope="col">
            {{ "company.transaction.filters.status" | translate }}
          </th>
          <th scope="col">
            <!-- {{ 'company.transaction.filters.booked' | translate }} -->
            {{ "company.transaction.filters.service" | translate }}
          </th>
          <!-- <th scope="col" id="auth">
                        {{ 'company.transaction.filters.auth_code' | translate }}</th> -->
          <th scope="col">
            {{ "company.transaction.filters.created" | translate }}
          </th>
          <th scope="col">
            {{ "company.transaction.filters.amount" | translate }}
          </th>
          <th></th>
        </thead>
        <tbody>
          <!-- DATA TABLE -->
          <tr *ngFor="let transaction of transactions; let i = index">
            <td class="align-text">
              <ng-container *ngIf="transaction?.usersNames?.length; else singleUser">
                <div *ngFor="let name of transaction.usersNames">{{ name }}</div>
              </ng-container>
              <ng-template #singleUser>
                {{ transaction.user || '–' }}
              </ng-template>
            </td>
            <td>
              <p class="align-text"
                *ngIf="
                  ['flight', 'car'].includes(transaction.service) &&
                  transaction.bookedObject?.length">
                {{
                  transaction.bookedObject[0]?.from && transaction.bookedObject[0]?.to
                    ? transaction.bookedObject[0].from + ' - ' + transaction.bookedObject[0].to
                    : transaction.bookedObject[0]?.from || '–'
                }}
              </p>
              <p class="align-text"
                *ngIf="
                  'train' === transaction.service &&
                  transaction.bookedObject?.length">
                {{ transaction.bookedObject[0]?.origin && transaction.bookedObject[0]?.destination ? 
                  transaction.bookedObject[0]?.origin?.name + ' - ' + transaction.bookedObject[0]?.destination?.name :
                  transaction.bookedObject[0]?.from && transaction.bookedObject[0]?.to
                    ? transaction.bookedObject[0].from + ' - ' + transaction.bookedObject[0].to
                    : transaction.bookedObject[0]?.from || '–'
                }}
              </p>

              <p class="align-text" *ngIf="transaction.service === 'room' && transaction.bookedObject?.length">
                {{
                  transaction.bookedObject[0]?.hotel
                    ? transaction.bookedObject[0]?.hotel.name + ' - ' + transaction.bookedObject[0]?.hotel.destinationName
                    : transaction.bookedObject[0]?.hotelName + ' - ' + transaction.bookedObject[0]?.destinationName
                }}
              </p>

              <p class="align-text" *ngIf="transaction.service === 'expense' && transaction.bookedObject?.length">
                {{ transaction.bookedObject[0]?.type }}
              </p>
            </td>
          
            <td>
              <p class="align-text">
                {{ transaction.order || '-' }}
              </p>
            </td>

            <td>
              <p *ngIf="transaction.type?.toLowerCase() === 'payment'" style="color: #10B981">
                {{ "company.transaction.filters.type-payment" | translate }}
              </p>
              <p *ngIf="transaction.type?.toLowerCase() === 'refund'" style="color: #ED5A46">
                {{ "company.transaction.filters.type-refund" | translate }}
              </p>
              <p *ngIf="transaction.type?.toLowerCase() === 'cancelled'" style="color:#9CA3AF">
                {{ "company.transaction.filters.type-cancelled" | translate }}
              </p>
              <p *ngIf="transaction.type?.toLowerCase() === 'pending'">
                {{ "company.transaction.filters.type-pending" | translate }}
              </p>
              <p *ngIf="transaction.type?.toLowerCase() === 'pendingcancel'" style="color:#F59E0B">
                {{ "company.transaction.filters.pending-cancelled" | translate }}
              </p>
            </td>
            <td>
              <p
                *ngIf="
                  transaction.service !== '' &&
                  transaction.service !== 'expense' &&
                  transaction.service !== 'flight' &&
                  transaction.service !== 'train' &&
                  transaction.service !== 'car'
                "
              >
                {{ "company.transaction.hotel" | translate }}
              </p>
              <p *ngIf="transaction.service === 'expense'">
                {{ "expenses.title" | translate }}
              </p>
              <p *ngIf="transaction.service === 'flight'">
                {{ "company.transaction.flight" | translate }}
              </p>
              <p *ngIf="transaction.service === 'train'">
                {{ "company.transaction.train" | translate }}
              </p>
              <p *ngIf="transaction.service === 'car'">
                {{ "company.transaction.car" | translate }}
              </p>
              <p *ngIf="transaction.service === ''">
                {{ "company.transaction.filters.no-booked-create" | translate }}
              </p>
            </td>
            <td>
              <p>{{ getDate(transaction.createdAt) }}</p>
            </td>
            <td>
              <p>{{ transaction.amount | price }} €</p>
            </td>
            <td id="container-buttons" ngbDropdown>
              <a *ngIf="transaction.service !== 'expense' || isEmployee" ngbDropdownToggle>
                <img class="pointer" src="assets/img/svg/black-kebab.svg" />
                <div ngbDropdownMenu>
                  <p class="text-left" (click)="onView(transaction)">
                    <img src="assets/img/svg/black-eye.svg" />
                    Ver reserva</p>

                  <p class="text-left" (click)="onDeliveryNote(transaction)">
                    <img src="assets/img/svg/black-bill-2.svg" />
                    {{ (transaction.type | lowercase) === 'refund' ? ('project.delivery-note-refund' | translate) : ('project.delivery-note' | translate) }}
                  </p>

                  <p class="text-left" *ngIf="transaction.type === 'pending' && isEmployee"
                  (click)="doTransactionAction(transaction, 'PAYMENT')">
                    <img src="assets/img/svg/black-bill-2.svg" />
                    {{ "company.transaction.filters.action-pay" | translate }}</p>

                  <p class="text-left" *ngIf="transaction.type === 'payment' && isEmployee"
                  (click)="doTransactionAction(transaction, 'REFUND')">
                    <img src="assets/img/svg/black-bill-2.svg" />
                    {{ "company.transaction.filters.action-refund" | translate }}</p>

                    <p class="text-left d-flex" *ngIf="isEmployee" (click)="openEditModal(transaction)">
                      <img src="assets/img/svg/black-edit-2.svg" id="edit-img" />
                      {{ 'agency.agency-card.edit' | translate }}</p>
                    <p
                      class="text-left"
                      *ngIf="isEmployee"
                      (click)="onDelete(transaction)"
                    >
                      <img src="assets/img/svg/black-trash.svg" />
                      {{ 'common.delete' | translate }}
                    </p>
                </div>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </form>

    <div
      class="text-center my-5"
      *ngIf="transactions.length === 0 && !loading"
    >
      <img
        class="not_found_image"
        src="assets/img/gallery/flights-not-found.svg"
        alt="No hay transacciones"
      />

      <h3 class="mt-2">
        <b>
          {{ "company.transaction.no-transaction" | translate }}
        </b>
      </h3>
    </div>
  </div>

  <div
    *ngIf="transactions.length > 0"
    class="d-flex justify-content-center mt-2 mb-2 col-12"
  >
    <mat-paginator
      #paginator
      [length]="totalTransactions"
      [pageIndex]="page - 1"
      [pageSize]="pageSize"
      (page)="getPaginatorData($event)"
      showFirstLastButtons
      [hidePageSize]="true"
      style="border-radius: 15px"
    >
    </mat-paginator>
  </div>
</div>